import { render } from "./PasswordRecoveryPage.vue?vue&type=template&id=256743de&scoped=true"
import script from "./PasswordRecoveryPage.vue?vue&type=script&lang=js"
export * from "./PasswordRecoveryPage.vue?vue&type=script&lang=js"

import "./PasswordRecoveryPage.vue?vue&type=style&index=0&id=256743de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-256743de"]])

export default __exports__